import React, { useState, useEffect } from 'react';
import '../../styles/ChangePassword.css';
import { fetchSubscriptionChangePasswordUserApi } from '../../api/api';
import { useNavigate, useSearchParams } from 'react-router-dom';

const ChangePassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [emailParam, setEmailParam] = useState('');
  const [uuidParam, setUuidParam] = useState('');
  const [tokenParam, setTokenParam] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    setEmailParam(searchParams.get('uname') || '');
    setUuidParam(searchParams.get('uuid') || '');
    setTokenParam(searchParams.get('token') || '');
  }, [searchParams]);
  


  const handleChangePassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!newPassword || !confirmPassword) {
      setError('All fields are required');
      return;
    }

    if (newPassword !== confirmPassword) {
      setError('New passwords do not match');
      return;
    }

    if (newPassword.length < 6) {
      setError('New password must be at least 6 characters');
      return;
    }

    try {
      const response = await fetchSubscriptionChangePasswordUserApi(
        emailParam,
        uuidParam,
        newPassword,
        tokenParam
      );

      if (response.statuscode === 200) {
        setSuccess('Password changed successfully!');
        setNewPassword('');
        setConfirmPassword('');
        setTimeout(() => navigate('/login'), 3000);
      } else if (response.statuscode === 404) {
        setError(response.message || 'User not found');
      } else {
        setError(response.message || 'Invalid email or password');
      }
    } catch (err) {
      setError('Something went wrong. Please try again later.');
    }
  };

  return (
    <div className="change-password-container">
      <form className="change-password-form" onSubmit={handleChangePassword}>
        <h2>Change Password</h2>
        {error && <p className="error">{error}</p>}
        {success && <p className="success">{success}</p>}

        <div className="form-group">
          <label htmlFor="newPassword">New Password</label>
          <input
            id="newPassword"
            type="text"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Enter new password"
            autoComplete="new-password"
          />
        </div>

        <div className="form-group">
          <label htmlFor="confirmPassword">Confirm New Password</label>
          <input
            id="confirmPassword"
            type="text"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            placeholder="Re-enter new password"
            autoComplete="new-password"
          />
        </div>

        <button type="submit">Change Password</button>
      </form>
    </div>
  );
};

export default ChangePassword;
